const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZephyrInc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "106.91303mm",
    height: "14.612884mm",
    viewBox: "0 0 106.91303 14.612884",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient15"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#000000",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop15"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    },
    offset: 1,
    id: "stop16"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-20.498826,-103.712)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "none",
      strokeWidth: 0.264583
    },
    d: "m 43.68037,114.57408 h 0.14013 l 0.240223,0.0399 3.082865,0.82863 -0.150138,-0.22962 -1.421323,-2.45594 -0.150138,-0.33944 -0.09008,-0.25957 -0.09008,-0.34943 -0.520491,-2.45593 -0.130122,-0.23961 -0.170159,-0.2396 -0.380352,-0.37938 -0.320298,-0.32945 -0.300279,-0.24959 -0.360335,-0.28952 -0.350325,-0.13977 -22.210642,-3.77376 3.273042,2.95511 0.220204,0.17971 0.330307,0.19967 0.330308,0.1198 0.330306,0.0399 15.774661,2.04662 -14.643609,-0.10982 1.891757,1.9967 0.240224,0.21964 0.130121,0.10982 0.160148,0.0699 0.180168,0.0599 0.230214,0.02 0.480446,0.0299 11.460652,-0.10982 -10.109396,2.09654 1.851721,1.41765 0.170158,0.11981 0.300279,0.0998 0.230214,0.0299 0.320298,-0.0299 7.947386,-1.78705 -6.926437,3.35446 1.481376,0.9085 0.400373,0.18968 0.42039,0.0898 0.380354,0.01 0.370344,-0.0599 0.390363,-0.0898 0.340316,-0.0898 0.220205,-0.0799 4.634307,-3.025 0.210195,-0.0799 z",
    id: "path1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f64ad",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.264583
    },
    d: "m 54.260202,109.00328 -5.46508,5.48095 h 5.46508 v 1.34777 h -8.537935 v -0.91848 l 5.555163,-5.46098 h -5.144781 v -1.34777 h 8.127553 z",
    id: "path2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f64ad",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.264583
    },
    d: "m 62.177559,115.832 h -6.335887 v -7.72723 h 6.075646 v 1.34777 h -3.793525 v 1.82698 h 3.533283 v 1.33779 h -3.533283 v 1.86692 h 4.053766 z",
    id: "path3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f64ad",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.264583
    },
    d: "m 66.2013,113.13645 v 2.69555 h -2.282121 v -7.72723 h 3.673414 c 2.672485,0 3.993711,0.81864 3.993711,2.44596 0,0.79868 -0.40037,1.42764 -1.201116,1.90685 -0.800743,0.4792 -1.811684,0.69884 -3.0128,0.67887 z m 0,-3.75379 v 2.49587 h 0.99092 c 1.331238,0 2.001862,-0.4193 2.001862,-1.25792 0,-0.82863 -0.670624,-1.23795 -1.981843,-1.23795 z",
    id: "path4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f64ad",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.264583
    },
    d: "m 82.316277,115.832 h -2.282121 v -3.18474 h -4.554233 v 3.18474 h -2.272112 v -7.72723 h 2.272112 v 3.12483 h 4.554233 v -3.12483 h 2.282121 z",
    id: "path5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f64ad",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.264583
    },
    d: "m 92.74597,108.10477 -3.483237,4.97178 v 2.75545 h -2.282121 v -2.7255 l -3.403164,-5.00173 h 2.61243 l 1.791663,2.95511 c 0.04004,0.0599 0.120113,0.26956 0.250232,0.609 h 0.03003 c 0.06006,-0.22962 0.13012,-0.42929 0.230214,-0.58903 l 1.841712,-2.97508 z",
    id: "path6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f64ad",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.264583
    },
    d: "m 102.7853,115.832 h -2.62244 l -1.68156,-2.00668 c -0.340317,-0.41931 -0.630586,-0.68887 -0.840782,-0.79868 -0.230214,-0.12979 -0.460428,-0.17971 -0.71066,-0.17971 h -0.680633 v 2.98507 h -2.282121 v -7.72723 h 3.743481 c 2.542365,0 3.813545,0.70883 3.813545,2.09653 0,0.52913 -0.2102,0.97839 -0.6406,1.35776 -0.42039,0.37937 -1.000928,0.63894 -1.751625,0.7887 v 0.02 c 0.490456,0.1198 1.040965,0.50916 1.631515,1.17805 z m -6.536075,-6.46931 v 2.22632 h 1.111033 c 0.530492,0 0.960893,-0.1198 1.281192,-0.33944 0.320297,-0.21964 0.490455,-0.50916 0.490455,-0.83861 0,-0.69885 -0.58054,-1.04827 -1.73161,-1.04827 z",
    id: "path7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#5f64ad",
      strokeWidth: "0.15014px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 54.260202,109.00328 -5.46508,5.48095 h 5.46508 v 1.34777 h -8.537935 v -0.91848 l 5.555163,-5.46098 h -5.144781 v -1.34777 h 8.127553 z",
    id: "path8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#5f64ad",
      strokeWidth: "0.15014px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 62.177559,115.832 h -6.335887 v -7.72723 h 6.075646 v 1.34777 h -3.793525 v 1.82698 h 3.533283 v 1.33779 h -3.533283 v 1.86692 h 4.053766 z",
    id: "path9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#5f64ad",
      strokeWidth: "0.15014px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 66.2013,113.13645 v 2.69555 h -2.282121 v -7.72723 h 3.673414 c 2.672485,0 3.993711,0.81864 3.993711,2.44596 0,0.79868 -0.40037,1.42764 -1.201116,1.90685 -0.800743,0.4792 -1.811684,0.69884 -3.0128,0.67887 z m 0,-3.75379 v 2.49587 h 0.99092 c 1.331238,0 2.001862,-0.4193 2.001862,-1.25792 0,-0.82863 -0.670624,-1.23795 -1.981843,-1.23795 z",
    id: "path10"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#5f64ad",
      strokeWidth: "0.15014px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 82.316277,115.832 h -2.282121 v -3.18474 h -4.554233 v 3.18474 h -2.272112 v -7.72723 h 2.272112 v 3.12483 h 4.554233 v -3.12483 h 2.282121 z",
    id: "path11"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#5f64ad",
      strokeWidth: "0.15014px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 92.74597,108.10477 -3.483237,4.97178 v 2.75545 h -2.282121 v -2.7255 l -3.403164,-5.00173 h 2.61243 l 1.791663,2.95511 c 0.04004,0.0599 0.120113,0.26956 0.250232,0.609 h 0.03003 c 0.06006,-0.22962 0.13012,-0.42929 0.230214,-0.58903 l 1.841712,-2.97508 z",
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#5f64ad",
      strokeWidth: "0.15014px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 102.7853,115.832 h -2.62244 l -1.68156,-2.00668 c -0.340317,-0.41931 -0.630586,-0.68887 -0.840782,-0.79868 -0.230214,-0.12979 -0.460428,-0.17971 -0.71066,-0.17971 h -0.680633 v 2.98507 h -2.282121 v -7.72723 h 3.743481 c 2.542365,0 3.813545,0.70883 3.813545,2.09653 0,0.52913 -0.2102,0.97839 -0.6406,1.35776 -0.42039,0.37937 -1.000928,0.63894 -1.751625,0.7887 v 0.02 c 0.490456,0.1198 1.040965,0.50916 1.631515,1.17805 z m -6.536075,-6.46931 v 2.22632 h 1.111033 c 0.530492,0 0.960893,-0.1198 1.281192,-0.33944 0.320297,-0.21964 0.490455,-0.50916 0.490455,-0.83861 0,-0.69885 -0.58054,-1.04827 -1.73161,-1.04827 z",
    id: "path13"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#5f64ad",
      fillOpacity: 1,
      fillRule: "evenodd"
    },
    d: "m 104.23027,114.86077 h -0.13012 l -0.25024,0.0399 -3.07285,0.82863 0.15014,-0.22962 1.42132,-2.45594 0.15014,-0.33944 0.0901,-0.25957 0.0801,-0.34942 0.5305,-2.45595 0.13011,-0.2396 0.17016,-0.2396 0.38036,-0.37938 0.31029,-0.32945 0.30027,-0.23961 0.37035,-0.2995 0.34031,-0.13977 22.21064,-3.77377 -3.26303,2.95512 -0.22021,0.1797 -0.34031,0.19967 -0.3203,0.11981 -0.34032,0.0399 -15.77465,2.04662 14.6436,-0.10982 -1.88175,1.9967 -0.25023,0.22962 -0.13012,0.0998 -0.16015,0.0699 -0.17016,0.0599 -0.23021,0.02 -0.48045,0.0299 -11.46064,-0.10982 10.09938,2.09654 -1.85172,1.41766 -0.17016,0.1198 -0.29027,0.0998 -0.23021,0.0299 -0.3203,-0.0299 -7.94738,-1.78705 6.91642,3.36444 -1.48137,0.89852 -0.39037,0.18969 -0.4304,0.0898 -0.37034,0.01 -0.37034,-0.0599 -0.40038,-0.0799 -0.34031,-0.0998 -0.2102,-0.0799 -4.6343,-3.02501 -0.2102,-0.0799 z",
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f64ad",
      fillOpacity: 1,
      fillRule: "evenodd"
    },
    d: "m 43.828732,114.73273 h 0.13012 l 0.25024,0.0399 3.07285,0.82863 -0.15014,-0.22962 -1.42132,-2.45593 -0.15014,-0.33944 -0.0901,-0.25957 -0.0801,-0.34942 -0.53051,-2.45595 -0.13011,-0.2396 -0.17015,-0.2396 -0.38036,-0.37938 -0.3103,-0.32945 -0.30026,-0.23961 -0.37035,-0.29949 -0.34032,-0.13977 -22.21063,-3.77377 3.26303,2.95511 0.22021,0.1797 0.34031,0.19967 0.3203,0.11981 0.34032,0.0399 15.77464,2.04661 -14.64359,-0.10982 1.88175,1.99671 0.25023,0.22961 0.13012,0.0998 0.16015,0.0699 0.17016,0.0599 0.23021,0.02 0.48045,0.0299 11.46064,-0.10982 -10.09938,2.09654 1.85172,1.41767 0.17015,0.11979 0.29028,0.0998 0.23021,0.0299 0.3203,-0.0299 7.94737,-1.78704 -6.91641,3.36444 1.48137,0.89853 0.39036,0.18968 0.43041,0.0898 0.37034,0.01 0.37034,-0.0599 0.40038,-0.0799 0.34031,-0.0998 0.2102,-0.0799 4.63429,-3.02501 0.21021,-0.0799 z",
    id: "path14-0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZephyrInc);
export default __webpack_public_path__ + "static/media/zephyr_inc.de62a4d4a875b8725ffb0a7ece57e2e7.svg";
export { ForwardRef as ReactComponent };